import React, { useState } from "react";
import SMSMagicSvg from "../../assets/svg/SMS-Magic.svg";
import RightIcon from "../../assets/svg/RightIcon.svg";
import SalesforceImg from "../../assets/svg/Salesforce_logo_img.svg.png";

const DataCenter = ({ state, callSignupAPI }) => {
  // let state = {
  //   dataCenter: "US",
  //   addons: {
  //     type: "install",
  //     package_installed: false,
  //     account_exists: true,
  //     latest_version: "1.73",
  //     upgrade_available: true,
  //     package_version: "1.72.22",
  //   },
  // };

  // eslint-disable-next-line no-unused-vars
  const [country, setCountry] = useState(
    state?.dataCenter == "US" // eslint-disable-line eqeqeq
      ? "United States"
      : state?.dataCenter == "EU" // eslint-disable-line eqeqeq
      ? "Europe"
      : "Australia"
  );

  const handleContinue = async () => {
    if (
      state?.addons?.type == "install" && // eslint-disable-line eqeqeq
      state?.addons?.package_installed == true // eslint-disable-line eqeqeq
    ) {
      await callSignupAPI("continueWorkspace");
    } else if (
      state?.addons?.type == "install" && // eslint-disable-line eqeqeq
      state?.addons?.package_installed == false // eslint-disable-line eqeqeq
    ) {
      await callSignupAPI();
    }
  };

  return (
    <>
      {/* <main  > */}
      <div
        className="main-content"
        style={{ minWidth: "700px", maxWidth: "44rem", marginTop: "4rem" }}
      >
        {state?.addons?.type == "install" && // eslint-disable-line eqeqeq
          state?.addons?.package_installed == true && ( // eslint-disable-line eqeqeq
            <div className="icon-container">
              <img src={SMSMagicSvg} alt="SMS-Magic Icon" className="icon" />
              <div className="dotted-line" />
              <div>
                <img
                  src={RightIcon}
                  alt={"Right Icon"}
                  className={"right-icon"}
                />
              </div>
              <div className="dotted-line" />
              {/* {error ? <div className="dotted-line-red" /> :<div className="dotted-line" />} */}
              <div className="salesforce-logo-container">
                <img
                  src={SalesforceImg}
                  alt="Salesforce Logo"
                  className="salesforce-logo"
                />
              </div>
            </div>
          )}

        <div className="installation-text" style={{ marginBottom: "30px" }}>
          {state?.addons?.type == "install" && // eslint-disable-line eqeqeq
          state?.addons?.package_installed == true ? ( // eslint-disable-line eqeqeq
            <>
              <h1 className="title" style={{ marginTop: 0 }}>
                You already have an SMS Magic account with
              </h1>
              <h2 className="subtitle">
                packages installed on {country} data center.
              </h2>
            </>
          ) : (
            <h1>
              You already have an SMS Magic account on {country} data center.
            </h1>
          )}

          <p className="subtitle-magic">
            Do you want to continue on existing account?
          </p>
          <button
            className="install-packages"
            style={{
              fontSize: "14px",
              color: "white",
              padding: "0px 15px",
              width: "250px",
            }}
            onClick={handleContinue}
          >
            {/* <span > */}
            Continue on existing account
            {/* </span> */}
          </button>

          <p className="subtitle-magic">
            <span>
              {/* Contact:{" "}  */}
              <a
                href="mailto:care@screen-magic.com"
                style={{ textDecoration: "none" }}
              >
                {" "}
                Contact: care@screen-magic.com{" "}
              </a>{" "}
              to create an account with different data center.
            </span>
          </p>
        </div>
      </div>
    </>
  );
};

export default DataCenter;